import './Spinner.scss'

export const Spinner = ({ size = 'md', text, className = '' }) => {
  const classes = ['tb-spinner-container', className].filter(Boolean).join(' ')

  return (
    <div className={classes}>
      <div className={`tb-spinner tb-spinner--${size}`}>
        <div className="tb-spinner__ring" />
        <div className="tb-spinner__ring" />
        <div className="tb-spinner__ring" />
        <div className="tb-spinner__dot" />
      </div>
      {text && <p className="tb-spinner__text">{text}</p>}
    </div>
  )
}

export const PageLoader = ({ text = 'Cargando...' }) => (
  <div className="tb-page-loader">
    <Spinner size="lg" text={text} />
  </div>
)
